import { Info } from "lucide-react";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

type HoverDetailsProps = {
  content: React.ReactNode; 
};

export const HoverDetails = ({ content }: HoverDetailsProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          size="icon"
          variant="ghost"
          className="rounded-full shadow-none"
          aria-label="Open detail menu"
        >
          <Info size={16} aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="pb-2 bg-black text-white text-center text-xs">
        {content}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default HoverDetails;
